<template>
	<div class="page-content">
		<div class="container">
			<!-- 第一行：头像/地址/vip/复制 -->
			<div style="margin: 0px;padding: 25px 6px;">
				<div class="row">
					<div style="display:flex;gap:12px;align-items:center">
						<img style="width:44px;height:44px;border-radius:16px;" src="images/staff.png" />

						<div>
							<div class="h2" id="meAddr">{{shortAddress}}</div>
							<div class="muted">
								<span data-lang="t_100"></span> 
								<span style="color: #F00;">{{speedLevel}}</span> 
								<span data-lang="t_101"></span>
							</div>
						</div>
					</div>
					<button class="btn" @click="btnCopyWallet()" data-lang="t_102"></button>
				</div>
			</div>

			<!-- 第三行：划拨 -->
			<div class="card pad section">
				<div class="row" style="border-bottom: 1px solid #5D6F90;">
					<div class="title">
						<span data-lang="t_103"></span>
						<span class="v" style="color: #F00;">
							VIP{{bonusLeval}}
						</span>
					</div>
					<button class="btn btn-link" @click="on_odal_shareholder_click()" data-lang="t_406"></button>
				</div>
				<!-- 第五行：股东收益/领取 -->
				<div class="row">
					<div>
						<div class="title">
							<span data-lang="t_104"></span>
							<span class="v">{{shareProfit}}</span>
						</div>
					</div>
					<button class="btn btn-primary" style="width:110px" @click="onTakeVipAbous()" data-lang="t_105"></button>

				</div>


			</div>

			<!-- 第四行：我的ATM/利润/提现 -->
			<div class="card pad section" style="text-align: center;padding: 12px 0px 0px 0px">
				<div class="row" style="margin: 12px 12px 0px 12px;">
					<input v-model="inToOutInputBox" type="number" @change="onInToOutInputBoxChange()"
						data-placeh="t_106" />
					<button class="btn btn-primary" style="width:110px" @click="InsideToOut()" data-lang="t_107"></button>

				</div>
				<div style="margin-top: 0px;text-align: left;padding-left: 12px;">
					<div class="muted">
						<span data-lang="t_108"></span>
						{{creditedATM}}A，
						<span data-lang="t_109"></span>
						{{handlingFeeATM}}A</div>
				</div>
				<div class="grid grid-2" style="margin: 12px 12px;">
					<div class="item_1">
						<div class="title" data-lang="t_110"></div>
						<div class="v">{{balanceOfAccount}}</div>
					</div>
					<div class="item_1">
						<div class="title" data-lang="t_111"></div>
						<div class="v">{{canTakeATM}}</div>
					</div>
					<!--
					<div class="item_1">
						<div class="title" data-lang="t_111_1"></div>
						<div class="v">{{canToBTL}}</div>
					</div>
					<div class="item_1">
						<button @click="onExchangeBTL" class="btn btn-primary">兑换BTL</button>
					</div>-->
				</div>
				<div class="grid grid-3" style="background-color: rgba(255, 255, 255, 0.1);border-radius: 12px;">
					<div class="item_1">
						<div class="title" data-lang="t_112"></div>
						<div class="v">{{balanceOfUSDT}}</div>
					</div>
					<div class="item_1">
						<div class="title" data-lang="t_113"></div>
						<div class="v">{{balanceOfBNB}}</div>
					</div>
					<div class="item_1">
						<div class="title" data-lang="t_114"></div>
						<div class="v">{{balanceOfATM}}</div>
					</div>
				</div>
				<div class="grid grid-2">
					<div class="item_1">
						<div class="title" data-lang="t_115"></div>
						<div class="v">{{poolMine}}</div>
					</div>
					<div class="item_1">
						<div class="title" data-lang="t_116"></div>
						<div class="v">{{poolProfit}}</div>
					</div>
					<div class="item_1">
						<div class="title" data-lang="t_117"></div>
						<div class="v">{{poolExchange}}</div>
					</div>
					<div class="item_1">
						<div class="title" data-lang="t_118"></div>
						<div class="v">{{poolBonus}}</div>
					</div>
					<div class="item_1">
						<div class="title" data-lang="t_119"></div>
						<div class="v">{{poolDestrop}}</div>
					</div>

					<div class="item_1">
						<div class="title" data-lang="t_120"></div>
						<div class="v">{{UserPower}} G</div>
					</div>
				</div>
			</div>

			<!-- 第七行：矮 Banner -> 邀请弹窗 -->
			<div class="banner section" style="cursor:pointer" @click="showQrCode()">
				<div class="big" data-lang="t_121"></div>
				<div class="small" data-lang="t_122"></div>
			</div>

			<!-- 第八~十一：条目 -->
			<div class="card pad section"  @click="sendDataToParent('team')">
				<div class="row">
					<div class="h2" >我的团队</div>
					<span class="muted">&gt;</span>
				</div>
			</div>
			
			<div class="card pad section"  @click="sendDataToParent('yszc')">
				<div class="row">
					<div class="h2" data-lang="t_123"></div>
					<span class="muted">&gt;</span>
				</div>
			</div>
			<div class="card pad section" @click="sendDataToParent('about')">
				<div class="row">
					<div class="h2" data-lang="t_124"></div><span class="muted">&gt;</span>
				</div>
			</div>
			<div class="card pad section" @click="sendDataToParent('service')">
				<div class="row">
					<div class="h2" data-lang="t_125"></div><span class="muted">&gt;</span>
				</div>
			</div>
			<div class="card pad section"  @click="sendDataToParent('terms')">
				<div class="row">
					<div class="h2" data-lang="t_126"></div><span class="muted">&gt;</span>
				</div>
			</div>
		</div>

		<!-- 股东级别（全屏弹窗：今日分红/日期/柱状图/历史记录无限加载） -->
		<div class="modalMask fullscreen" :class="{show:odal_shareholder == true}" id="modal-shareholder">
			<div class="modal">
				<div class="modalHead">
					<div data-lang="t_127"></div>
					<div class="modalClose" data-close="modal-shareholder" @click="odal_shareholder = false">×</div>
				</div>
				<div class="vip-container">
					<div class="vip-header">
						<h1 class="vip-title" data-lang="t_128"></h1>
					</div>

					<div class="vip-chart-container">

						<div class="vip-chart" id="vip-barChart">
							<!-- 网格线 -->
							<div class="vip-grid-line" style="bottom: 0%;"></div>
							<div class="vip-grid-line" style="bottom: 20%;"></div>
							<div class="vip-grid-line" style="bottom: 40%;"></div>
							<div class="vip-grid-line" style="bottom: 60%;"></div>
							<div class="vip-grid-line" style="bottom: 80%;"></div>
							<div class="vip-grid-line" style="bottom: 100%;"></div>
							<div class="vip-bar-container">
								<div class="vip-bar" :style="{ height: heightV1 + 'px' }">
									<div class="vip-bar-value">{{people1}}</div>
								</div>
								<div class="vip-bar-label">v1</div>
							</div>

							<div class="vip-bar-container">
								<div class="vip-bar" :style="{ height: heightV2 + 'px' }">
									<div class="vip-bar-value">{{people2}}</div>
								</div>
								<div class="vip-bar-label">v2</div>
							</div>

							<div class="vip-bar-container">
								<div class="vip-bar" :style="{ height: heightV3 + 'px' }">
									<div class="vip-bar-value">{{people3}}</div>
								</div>
								<div class="vip-bar-label">v3</div>
							</div>

							<div class="vip-bar-container">
								<div class="vip-bar" :style="{ height: heightV4 + 'px' }">
									<div class="vip-bar-value">{{people4}}</div>
								</div>
								<div class="vip-bar-label">v4</div>
							</div>

							<div class="vip-bar-container">
								<div class="vip-bar" :style="{ height: heightV5 + 'px' }">
									<div class="vip-bar-value">{{people5}}</div>
								</div>
								<div class="vip-bar-label">v5</div>
							</div>
						</div>

					</div>
					<div class="field" style="margin-bottom: 12px;">
						<div class="row">
							<textarea rows="2" v-model="makerAddress"  data-placeh="t_407"></textarea>
							<button class="btn btn-mini" style="margin-left: 0px;" data-lang="t_408" @click="ApplyMaker()"></button>
						</div>
					</div>
				</div>

			</div>
		</div>

		<!-- 邀请链接弹窗：二维码 + 复制 -->
		<div class="modalMask" :class="{show:modal_invite == true}">
			<div class="modal">
				<div class="modalHead">
					<div data-lang="t_129"></div>
					<div class="modalClose" @click="modal_invite = false">×</div>
				</div>
				<div class="modalBody" style="text-align: center;">
					<div class="item_1">
						<div class="title" data-lang="t_130"></div>
						<div class="v" id="inviteLink" style="font-size:13px;word-break:break-all;margin-top:6px">
							{{refURL}}
						</div>

						<div class="modalBody">
							<div>
								<div id="qrcode_box" class="muted"
									style="width: 200px;height: 200px;margin: auto;border-radius: 15px;padding: 15px;border:1px solid rgba(255,255,255,.10);background:rgba(255,255,255,.05)">

								</div>
								<div class="title" data-lang="t_131"></div>
							</div>

						</div>

					</div>
				</div>
				<div class="modalFoot">
					<button class="btn" @click="modal_invite = false" data-lang="t_132"></button>
					<button class="btn btn-primary" @click="copyRefUrl()" data-lang="t_133"></button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Profile',
		data() {
			return {
				shortAddress: "",
				speedLevel: 5, //加速层级
				bonusLeval: 0, //分红等级
				UserId: 0,
				shareProfit: 0, //股东收益
				balanceOfATM: 0,
				balanceOfAccount: 0, //内盘余额
				balanceOfUSDT: 0,
				balanceOfBNB: 0,
				canTakeATM: 0, //提币额度
				canToBTL:0,//兑换btl的额度

				poolMine: 0, //矿池
				poolProfit: 0, //利润池
				poolExchange: 0, //担保池
				poolBonus: 0, //分红池				
				poolDestrop: 0, //销毁池

				inToOutInputBox: "", //提币的输入框
				creditedATM: 0, //到账
				handlingFeeATM: 0, //手续费

				modal_invite: false, //邀请好友弹窗
				refURL: "", //推荐地址

				odal_shareholder: false, //显示股东级别对话框

				heightV1: 0, //v1柱状图高度
				heightV2: 0, //v2柱状图高度
				heightV3: 0, //v3柱状图高度
				heightV4: 0, //v4柱状图高度
				heightV5: 0, //v5柱状图高度

				people1: 0, //柱状图显示的人数
				people2: 0, //柱状图显示的人数
				people3: 0, //柱状图显示的人数
				people4: 0, //柱状图显示的人数
				people5: 0, //柱状图显示的人数
				
				UserPower:0,//算力
				makerAddress:"",//做市商地址
			}
		},
		mounted() {
			this.setLanguage();
			this.shortAddress = shortAccount;
			this.showUI();
		},
		methods: {
			setLanguage(){
				let elements = document.querySelectorAll('[data-lang]');
				elements.forEach(element => {
				    const langValue = element.getAttribute('data-lang');
				    element.innerHTML = Lang[lg][langValue];
				});
				elements = document.querySelectorAll('[data-placeh]');
				elements.forEach(element => {
				    const langValue = element.getAttribute('data-placeh');
				    element.placeholder = Lang[lg][langValue];
				});
			},
			btnCopyWallet() { //复制钱包
				copyRefURL(Account);
			},
			copyRefUrl() { //复制二维码
				copyRefURL(this.refURL);
				this.modal_invite = false;
			},
			sendDataToParent(page) {
			      this.$emit('data-received', {
			        message: page,
			        timestamp: new Date()
			      });
			},
			async on_odal_shareholder_click() {
				this.odal_shareholder = true;
				let sys = await conMine.getSysInfo().call();
				/*uint8 floor5;//5级人数 2
				uint16 floor4;//4级人数 4
				uint24 floor3;//7
				uint24 floor2;//10
				uint32 floor1;//14*/
				let max = Math.max(sys.floor5, sys.floor4, sys.floor3, sys.floor2, sys.floor1);
				
				if (isNaN(max)) return;
				if(max <1)max = 1;
				let rate = Math.floor(300 / max);
				this.heightV1 = Math.floor(sys.floor1 * rate);
				this.heightV2 = Math.floor(sys.floor2 * rate);
				this.heightV3 = Math.floor(sys.floor3 * rate);
				this.heightV4 = Math.floor(sys.floor4 * rate);
				this.heightV5 = Math.floor(sys.floor5 * rate);

				this.people1 = sys.floor1;
				this.people2 = sys.floor2;
				this.people3 = sys.floor3;
				this.people4 = sys.floor4;
				this.people5 = sys.floor5;

				
			},
			onInToOutInputBoxChange() {
				if (this.inToOutInputBox > this.balanceOfAccount) {
					this.creditedATM = 0;
					this.handlingFeeATM = 0;
				} else {
					this.creditedATM = Math.round(Number(this.inToOutInputBox) * 85) / 100;
					this.handlingFeeATM = Math.round(Number(this.inToOutInputBox) * 15) / 100;
				}

			},
			showQrCode() {
				this.modal_invite = true;
				const qrcodeDiv = document.getElementById('qrcode_box');
				qrcodeDiv.innerHTML = '';
				new QRCode(qrcodeDiv, {
					text: this.refURL,
					width: 170,
					height: 170,
					colorDark: "#000000",
					colorLight: "#ffffff",
					correctLevel: QRCode.CorrectLevel.H
				});
			},
			ReplaceCID(urlString, newCid) {
			    // 解析URL
			    const url = new URL(urlString);
			    // 提取路径中的CID部分
			    const pathParts = url.pathname.split('/').filter(part => part);
			    console.log(pathParts);
			    // 找到IPFS路径部分
			    const ipfsIndex = pathParts.indexOf('ipfs');
			    if (ipfsIndex === -1) {
			        throw new Error('URL中未找到IPFS路径');
			    }
			    
			    // 构建新的路径
			    const newPathParts = [...pathParts];
			    newPathParts[ipfsIndex + 1] = newCid; // 替换CID
			    
			    // 重新构建路径
			    const newPath = '/' + newPathParts.join('/');
			    
			    // 构建新的完整URL
			    const newUrl = new URL(url.origin + newPath);
			    newUrl.search = url.search;
			    newUrl.hash = url.hash;
			    
			    return {
			        originalUrl: urlString,
			        baseUrl: url.origin + '/' + pathParts.slice(0, ipfsIndex + 1).join('/') + '/',
			        newUrl: newUrl.toString(),
			        cid: newCid
			    };
			},
			async showUI() {

				const user = await conMine.getPeopleTree(Account).call();
				this.UserId = user.id;
				let url = window.location.toString();
				let c = url.indexOf("/?");
				if (c < 0) c = url.length;
				url = url.substring(0, c+1) + "?ref=" + Number(this.UserId).toString(16).toLocaleUpperCase();
				try{
					this.refURL = this.ReplaceCID(url,"bafybeigsxa2pgpfmepjbsxw43wytgdck4vfifr5musvdkbaouvvgcdzdym").newUrl;
				}catch(e){
					this.refURL = url;
				}
				
				await Sleep(this.$waitTime);
				const line = await conMine.getLine(this.UserId).call();
				this.speedLevel = line.quickenFloor;
				this.bonusLeval = line.bonusLeval > 100 ? line.bonusLeval - 100 : 0;
				if (line.bonusLeval > 100) { //我的分红
					this.shareProfit = await conMine.getBonusBatch(Account, 0, 0).call();
					this.shareProfit = Number(this.shareProfit) / 100;
				}
				//各种余额
				await Sleep(this.$waitTime);
				let ATM = await conATM.balanceOf(Account).call();
				this.balanceOfATM = Number(ATM) / 100;
				
				
				
				this.balanceOfAccount = Number(user.balanceOf) / 100;
				this.canTakeATM = Number(user.inToOutQuota) / 100;
				this.canToBTL = Number(user.speedProfit) /100;
				await Sleep(this.$waitTime);
				const usdt = await conUSDT.balanceOf(Account).call();
				this.balanceOfUSDT = Math.floor(web3.utils.fromWei(usdt) * 100) / 100;
				await Sleep(this.$waitTime);
				const bnb = await web3.eth.getBalance(Account);
				this.balanceOfBNB = Math.floor(web3.utils.fromWei(bnb) * 10000) / 10000;
				await Sleep(this.$waitTime);
				let pool = await conATM.balanceOf(addrMine).call();
				this.poolMine = Number(pool) / 100;
				await Sleep(this.$waitTime);
				pool = await conATM.balanceOf(addrProfit).call();
				this.poolProfit = Number(pool) / 100; //利润池
				await Sleep(this.$waitTime);
				pool = await conATM.balanceOf(addrExc).call();
				this.poolExchange = Number(pool) / 100; //担保池
				await Sleep(this.$waitTime);
				pool = await conATM.balanceOf(addrBonus).call();
				this.poolBonus = Number(pool) / 100; //分红池	
				await Sleep(this.$waitTime);
				pool = await conATM.balanceOf(addrDestroy).call();
				this.poolDestrop = Number(pool) / 100; //销毁池
				//获得算力
				await Sleep(this.$waitTime);
				const userExc = await conExc.getUser(Account).call();
				this.UserPower = Number(userExc.power)/1000;
			},
			//领取分红
			async onTakeVipAbous() {

				try {
					if (await gasIsEnough() == false) return;
					MsgBox.waitTX(Lang[lg].t_134, Lang[lg].t_134);
					let par = {
						from: Account,
						to: addrMine,
						gasPrice: await web3.eth.getGasPrice(),
						nonce: await web3.eth.getTransactionCount(Account)
					};
					//takeAbouns(uint32 startDay,uint32 endDay)
					const gas = await conMine.takeAbouns(0, 0).estimateGas(par);
					par.gas = gas;
					const success = await conMine.takeAbouns(0, 0).send(par);
					MsgBox.open(Lang[lg].t_134, Lang[lg].t_135);
					this.showUI();

				} catch (e) {
					MsgBox.open(Lang[lg].t_134, e.message)
				}
			},
			async getNewID(){//生成一个随机id，并检测是否已被占用
				let newID = 0;
				let Index = 0;
				const min = 0x100000;
				const max = 0xFFFFFF;
				while(1){
					Index ++ ;
					newID = Math.floor(Math.random() * (max - min + 1)) + min;
					await Sleep(500);
					if(await conMine.getFindAddressFromId(newID).call() == addrNull)return newID;
					Toast.open(Lang[lg]['t_6'] + Index + Lang[lg]['t_7']);
					if(Index % 10 == 0){//如果5秒钟还没有生成合适的id，提示一下
						let result = await MsgBox.open(Lang[lg]['t_8'],Lang[lg]['t_9']);
						if(result == false)return 0;
					}
				}
			},
			//申请做市商
			async ApplyMaker(){
				if(!web3.utils.isAddress(this.makerAddress)){
					MsgBox.open(Lang[lg].t_8,Lang[lg].t_197);
					return;
				}
				let NewID =await getNewID() ;
				if(NewID == 0){
					MsgBox.open(Lang[lg]['t_8'],Lang[lg]['t_11']);
					return;
				}
				try {
					if (await gasIsEnough() == false) return;
					MsgBox.waitTX("申请做市商", "申请做市商");
					let par = {
						from: Account,
						to: addrMine,
						gasPrice: await web3.eth.getGasPrice(),
						nonce: await web3.eth.getTransactionCount(Account)
					};
				
					const gas = await conMine.Apply_market_maker(this.makerAddress,NewID).estimateGas(par);
					par.gas = gas;
					const success = await conMine.Apply_market_maker(this.makerAddress,NewID).send(par);
					MsgBox.open("申请做市商", "申请做市商成功");
					this.showUI();
				
				} catch (e) {
					MsgBox.open(Lang[lg].t_136, e.message)
				}
			},
			async InsideToOut() {


				//获得我的内盘数量
				const user = await conMine.getPeopleTree(Account).call();

				if (this.inToOutInputBox > Number(user.balanceOf) / 100) {
					MsgBox.open(Lang[lg].t_136, Lang[lg].t_137);
					return;
				}
				if (this.inToOutInputBox < 1) {
					MsgBox.open(Lang[lg].t_136, Lang[lg].t_138)
					return;
				}
				try {
					if (await gasIsEnough() == false) return;
					MsgBox.waitTX(Lang[lg].t_136, Lang[lg].t_136);
					let par = {
						from: Account,
						to: addrMine,
						gasPrice: await web3.eth.getGasPrice(),
						nonce: await web3.eth.getTransactionCount(Account)
					};

					const gas = await conMine.InsideToOut(Math.round(Number(this.inToOutInputBox) * 100).toString())
						.estimateGas(par);
					par.gas = gas;
					const success = await conMine.InsideToOut(Math.round(Number(this.inToOutInputBox) * 100)
					.toString()).send(par);
					MsgBox.open(Lang[lg].t_136, Lang[lg].t_139);
					this.showUI();

				} catch (e) {
					MsgBox.open(Lang[lg].t_136, e.message)
				}
				this.inToOutInputBox = "";
			},
			async onExchangeBTL(){
				if(this.canToBTL == 0){
					MsgBox.open("提示","没有可兑换为BTL的ATM");
					return;
				}
				try {
					if (await gasIsEnough() == false) return;
					MsgBox.waitTX(Lang[lg].t_136, "兑换BTL");
					let par = {
						from: Account,
						to: addrMine,
						gasPrice: await web3.eth.getGasPrice(),
						nonce: await web3.eth.getTransactionCount(Account)
					};
				
					const gas = await conMine.ExchangeBTL().estimateGas(par);
					par.gas = gas;
					const success = await conMine.ExchangeBTL().send(par);
					MsgBox.open(Lang[lg].t_136, "兑换btl成功");
					this.showUI();
				
				} catch (e) {
					MsgBox.open(Lang[lg].t_136, e.message)
				}
			},
		},
	}
</script>
<style>
	/* 只包含组件样式，没有全局样式 */
	.vip-container {
		width: 100%;
		max-width: 1000px;
		background-color: rgba(0, 0, 0, 0);
		border-radius: 12px;
		box-shadow: 0 8px 24px rgba(0, 150, 255, 0.15);
		padding: 30px;
		overflow-y: auto;
	}

	.vip-header {
		text-align: center;
		margin-bottom: 40px;
	}

	.vip-title {
		font-size: 2.4rem;
		margin-bottom: 10px;
		color: #4fc3f7;
		text-shadow: 0 0 10px rgba(79, 195, 247, 0.5);
	}

	.vip-subtitle {
		color: #8be9fd;
		font-size: 1.1rem;
		opacity: 0.9;
	}

	.vip-chart-container {
		position: relative;
		width: 100%;
		
	}

	.vip-chart {
		display: flex;
		align-items: flex-end;
		justify-content: space-around;
		height: 100%;
		padding: 20px 0;
		border-bottom: 2px solid #2a4a5f;
		position: relative;
	}

	.vip-y-axis {
		position: absolute;
		left: 0;
		top: 0;
		height: 100%;
		width: 50px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding-bottom: 20px;
		color: #8be9fd;
		font-size: 0.9rem;
		border: 1px solid #0277bd;
	}

	.vip-bar-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 16%;
		height: 100%;
		z-index: 2;
		position: relative;
	}

	.vip-bar {
		width: 70%;
		background: linear-gradient(to bottom, #0277bd, #4fc3f7);
		border-radius: 6px 6px 0 0;
		transition: all 0.3s ease;
		position: relative;
		box-shadow: 0 -4px 12px rgba(79, 195, 247, 0.3);
		cursor: pointer;
		align-self: flex-end;
		margin-top: auto;
	}

	.vip-bar:hover {
		transform: translateY(-5px);
		box-shadow: 0 -8px 20px rgba(79, 195, 247, 0.5);
	}

	.vip-bar-value {
		position: absolute;
		top: -30px;
		left: 50%;
		transform: translateX(-50%);
		background-color: rgba(0, 30, 60, 0.9);
		padding: 3px 0px;
		border-radius: 4px;
		font-weight: bold;
		color: #4fc3f7;
		opacity: 1;
		transition: opacity 0.3s;
		border: 1px solid #1a3a4d;
		min-width: 60px;
		text-align: center;
	}

	.vip-bar:hover .vip-bar-value {
		opacity: 1;
	}

	.vip-bar-label {
		position: absolute;
		bottom: -40px;
		left: 50%;
		transform: translateX(-50%);
		color: #8be9fd;
		font-weight: bold;
		font-size: 1.2rem;
		white-space: nowrap;
	}

	.vip-x-axis {
		display: flex;
		justify-content: space-around;
		margin-top: 50px;
		padding-top: 15px;
		border-top: 1px solid #2a4a5f;
		color: #8be9fd;
		font-weight: bold;
		font-size: 1.2rem;
	}

	.vip-data-display {
		background-color: rgba(0, 0, 0, 0);
		border-radius: 8px;
		padding: 20px;
		margin-top: 30px;
		border: 1px solid #1a3a4d;
	}

	.vip-grid-line {
		position: absolute;
		width: 100%;
		height: 1px;
		background-color: rgba(42, 74, 95, 0.5);
		z-index: 1;
	}

	@media (max-width: 768px) {
		.vip-container {
			padding: 20px;
		}

		.vip-title {
			font-size: 1.8rem;
		}

		.vip-chart-container {
			height: 350px;
		}

		.vip-bar-label,
		.vip-x-axis {
			font-size: 1rem;
		}
	}
</style>